import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useLoaderData, useNavigation, useParams } from 'react-router-dom'
import HeaderTwo from '../../Components/Header2/HeaderTwo';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import Footer from '../../Components/Footer/Footer';

export default function ProjectDetails() {
    const params = useParams();
    const [project, setProject] = useState([]);
    console.log(params)
    useEffect(() => {
        fetch('projectsData.json')
            .then(res => res.json())
            .then(data => {
                const filter = data.filter(d => d._id == params.id)
                setProject(filter);
                console.log(filter)
            })
    }, [])
    return (
        <div>
            <div className='lg:mx-12 mx-6'>
                <HeaderTwo />
                <div className='flex lg:flex-row gap-8 flex-col mt-12 '>
                    <div className='lg:w-1/2 w-full mb-4'>
                        <Swiper
                            spaceBetween={30}
                            centeredSlides={true}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}

                            modules={[Autoplay, Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {
                                project[0]?.img.map((image, index) => <SwiperSlide key={index + 'img'}>
                                    <img src={image} alt="" className=' w-full ' />
                                </SwiperSlide>)
                            }



                        </Swiper>
                    </div>
                    <div className='lg:w:1/2 w-full'>
                        <h3 className=' text-white text-center w-full uppercase font-bold text-2xl'>{project[0]?.name}</h3>
                        <p className=' text-white mt-4'>An E-Commerce website to sell used/second-hand watches with advertisement features.</p>
                        <div className=' flex gap-2 mt-4 text-red-500 justify-center'>
                            <a href={project[0]?.live_link} target='_blank' className='border  lg:p-2 p-1  rounded-lg uppercase font-bold shadow-lg shadow-white hover:text-green-500'>Live Link</a>
                            <a href={project[0]?.server} target='_blank' className='border hover:text-green-500 lg:p-2 p-1  rounded-lg uppercase font-bold shadow-lg shadow-white'>Server Code</a>
                            <a href={project[0]?.client} target='_blank' className='border hover:text-green-500 lg:p-2 p-1 rounded-lg uppercase font-bold shadow-lg shadow-white'>Client Code</a>


                        </div>
                        <h3 className=' text-white font-bold uppercase text-xl mt-8 mb-4'>Features:</h3>

                        <ol className=' text-white opacity-80 list-disc' >
                            {
                                project[0]?.features.map((feature, index) => <li key={index}>
                                    {feature}
                                </li>)
                            }
                        </ol>

                        <h3 className=' text-white font-bold uppercase text-xl mt-8 mb-4'>Technology:</h3>
                        <div className='flex gap-2 flex-wrap'>
                            {
                                project[0]?.tech.map((tech, index) => <p className='border rounded-lg shadow-lg shadow-white  p-4 text-green-500 uppercase font-bold' key={index}>
                                    {tech}
                                </p>)
                            }
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}
